import React from 'react';
import axios from 'axios';
import Geocode from 'react-geocode';

import SingleStockist from './SingleStockist';
import StockistsMap from './StockistsMap';

Geocode.setApiKey('AIzaSyCxEvfV9zJWqq4rDTV_or0QZqpvke82mDg');

class StockistsApp extends React.Component {
  constructor(props) {
    super(props);
    let majorIcon = window.stockistIcons.major;
    let coreIcon = window.stockistIcons.core;
    let limitedIcon = window.stockistIcons.limited;
    let mountsAccessoriesIcon = window.stockistIcons.mountsAccessories;
    let onlineOnlyIcon = window.stockistIcons.onlineOnly;
    let mobileIcon = window.stockistIcons.mobile;
    let saddleFitterIcon = window.stockistIcons.saddleFitter;
    let promo1Icon = window.stockistIcons.promo1;
    let promo2Icon = window.stockistIcons.promo2;

    this.state = {
      stockists: [],
      countries: [],
      provinces: [],
      selectedCountry: '',
      selectedProvince: '',
      nearbyStockists: [],
      userAddress: '',
      majorIcon,
      coreIcon,
      limitedIcon,
      mountsAccessoriesIcon,
      onlineOnlyIcon,
      mobileIcon,
      saddleFitterIcon,
      promo1Icon,
      promo2Icon,
      isLegendExpanded: true,
      legendExpandClasses: 'stockist__header stockists__list-header stockists__list-header--active',
      legendContentClasses: 'stockists-legend__wrapper stockists-legend__wrapper--active',
      center: {
        lat: -28.024,
        lng: 140.887,
      },
      legend: [
        {
          title: window.theme.strings.majorStockist,
          icon: majorIcon,
        },
        {
          title: window.theme.strings.coreStockist,
          icon: coreIcon,
        },
        {
          title: window.theme.strings.limitedStockist,
          icon: limitedIcon,
        },
        {
          title: window.theme.strings.mountsAccessories,
          icon: mountsAccessoriesIcon,
        },
        {
          title: window.theme.strings.onlineOnly,
          icon: onlineOnlyIcon,
        },
        {
          title: window.theme.strings.mobileStockist,
          icon: mobileIcon,
        },
        {
          title: window.theme.strings.specialPromotions,
          icon: promo1Icon,
        },
        {
          title: window.theme.strings.specialPromotions2,
          icon: promo2Icon,
        },
        {
          title: window.theme.strings.saddleFitter,
          icon: saddleFitterIcon,
        },
      ],
      icons: {
        major: majorIcon,
        core: coreIcon,
        limited: limitedIcon,
        mobile: mobileIcon,
        'accessories only': mountsAccessoriesIcon,
        onlineOnly: onlineOnlyIcon,
        saddleFitter: saddleFitterIcon,
        promo1: promo1Icon,
        promo2: promo2Icon,
      },
      showPlacesDropdown: true,
      autocompleteInputClasses: 'col-xs-12 form-input__hide',
      dropdownClasses: 'col-xs-12 col-sm-6',
      showMyLocationLink: true,
    };

    this.autocompleteInput = React.createRef();
    this.countrySelector = React.createRef();
    this.autocomplete = null;

    this.handleCountryChange = this.handleCountryChange.bind(this);
    this.handleProvinceChange = this.handleProvinceChange.bind(this);
    this.getNearbyStockists = this.getNearbyStockists.bind(this);
    this.handleHideShowLegend = this.handleHideShowLegend.bind(this);
    this.updateProvinces = this.updateProvinces.bind(this);
    this.handlePlaceChange = this.handlePlaceChange.bind(this);
    this.toggleAutocompleteInput = this.toggleAutocompleteInput.bind(this);
    this.getMyLocation = this.getMyLocation.bind(this);
  }

  handleCountryChange(evt) {
    const target = evt.target;
    const country = target.value;
    this.setState({
      selectedCountry: country,
    });
    this.updateProvinces(country);
  }

  updateProvinces(country) {
    const {stockists, selectedCountry} = this.state;
    const availableStockists = stockists.filter(stockist => stockist.state && stockist.country.trim() === country.trim());
    const availableProvinces = [...new Set(availableStockists.map(stockist => stockist.state.trim()))];
    const sortedProvinces = availableProvinces.sort();
    this.setState({
      provinces: sortedProvinces,
      selectedProvince: sortedProvinces[0],
    });
    Geocode.fromAddress(`${availableProvinces[0]}, ${selectedCountry}`)
      .then(response => {
        const location = response.results[0].geometry.location;
        this.setState({
          center: {
            lat: location.lat,
            lng: location.lng,
          },
        });
      },
      err => {
        window.console.log('Error', err);
      });
  }

  handleProvinceChange(evt) {
    const {selectedCountry} = this.state;
    const target = evt.target;
    const province = target.value;
    this.setState({
      selectedProvince: province.trim(),
    });
    Geocode.fromAddress(`${province}, ${selectedCountry}`)
      .then(response => {
        const location = response.results[0].geometry.location;
        this.setState({
          center: {
            lat: location.lat,
            lng: location.lng,
          },
        });
      },
      err => {
        window.console.log('Error', err);
      });
  }

  getNearbyStockists() {
    // const radius = 500000;
    const {stockists, center, selectedCountry, selectedProvince} = this.state;
    const nearbyStockists = [];
    const centerPosition = new google.maps.LatLng(center.lat, center.lng);
    const orderPriority = {
      major: 1,
      core: 2,
      limited: 3,
      'accessories only': 4,
    };

    const topStockists = [];
    const topStockistsFiltered = stockists.filter(stockist => stockist.country.trim() === selectedCountry.trim() && stockist.position === 'top');
    if (topStockistsFiltered.length > 0) {
      topStockistsFiltered.forEach(stockist => {
        if (stockist.lat && stockist.lng) {
          const stockistPosition = new google.maps.LatLng(stockist.lat, stockist.lng);
          const distance = (google.maps.geometry.spherical.computeDistanceBetween(stockistPosition, centerPosition) / 1000).toFixed(2);
          const stockistData = {
            stockist,
            distance,
          };
          topStockists.push(stockistData);
        } else {
          const stockistData = {
            stockist,
            distance: '-1',
          };
          topStockists.push(stockistData);
        }
      });
      const sortedTopStockists = topStockists.sort((item1, item2) => {
        if (orderPriority[item1.stockist.type.trim()] > orderPriority[item2.stockist.type.trim()]) {
          return 1;
        } else if (orderPriority[item1.stockist.type.trim()] < orderPriority[item2.stockist.type.trim()]) {
          return -1;
        }

        return parseFloat(item1.distance) - parseFloat(item2.distance);
      });
      sortedTopStockists.forEach(stockist => {
        nearbyStockists.push(stockist);
      });
    }

    const centerStockists = [];
    const centerStockistsFiltered = stockists.filter(stockist => stockist.country.trim() === selectedCountry.trim() && stockist.state.trim() === selectedProvince.trim() && (stockist.position === undefined || stockist.position === 'center'));
    if (centerStockistsFiltered.length > 0) {
      centerStockistsFiltered.forEach(stockist => {
        if (stockist.lat && stockist.lng) {
          const stockistPosition = new google.maps.LatLng(stockist.lat, stockist.lng);
          const distance = (google.maps.geometry.spherical.computeDistanceBetween(stockistPosition, centerPosition) / 1000).toFixed(2);
          const stockistData = {
            stockist,
            distance,
          };
          centerStockists.push(stockistData);
        } else {
          const stockistData = {
            stockist,
            distance: '-1',
          };
          centerStockists.push(stockistData);
        }
      });
      const sortedCenterStockists = centerStockists.sort((item1, item2) => {
        if (orderPriority[item1.stockist.type.trim()] > orderPriority[item2.stockist.type.trim()]) {
          return 1;
        } else if (orderPriority[item1.stockist.type.trim()] < orderPriority[item2.stockist.type.trim()]) {
          return -1;
        }

        return parseFloat(item1.distance) - parseFloat(item2.distance);
      });
      sortedCenterStockists.forEach(stockist => {
        nearbyStockists.push(stockist);
      });
    }

    const bottomStockists = [];
    const bottomStockistsFiltered = stockists.filter(stockist => stockist.country.trim() === selectedCountry.trim() && stockist.position === 'bottom');
    if (bottomStockistsFiltered.length > 0) {
      bottomStockistsFiltered.forEach(stockist => {
        if (stockist.lat && stockist.lng) {
          const stockistPosition = new google.maps.LatLng(stockist.lat, stockist.lng);
          const distance = (google.maps.geometry.spherical.computeDistanceBetween(stockistPosition, centerPosition) / 1000).toFixed(2);
          const stockistData = {
            stockist,
            distance,
          };
          bottomStockists.push(stockistData);
        } else {
          const stockistData = {
            stockist,
            distance: '-1',
          };
          bottomStockists.push(stockistData);
        }
      });
      const sortedBottomStockists = bottomStockists.sort((item1, item2) => {
        if (orderPriority[item1.stockist.type.trim()] > orderPriority[item2.stockist.type.trim()]) {
          return 1;
        } else if (orderPriority[item1.stockist.type.trim()] < orderPriority[item2.stockist.type.trim()]) {
          return -1;
        }

        return parseFloat(item1.distance) - parseFloat(item2.distance);
      });
      sortedBottomStockists.forEach(stockist => {
        nearbyStockists.push(stockist);
      });
    }
    this.setState({
      nearbyStockists,
    });
  }

  handleHideShowLegend() {
    const {isLegendExpanded} = this.state;
    if (isLegendExpanded) {
      this.setState({
        isLegendExpanded: false,
        legendExpandClasses: 'stockist__header stockists__list-header',
        legendContentClasses: 'stockists-legend__wrapper',
      });
    } else {
      this.setState({
        isLegendExpanded: true,
        legendExpandClasses: 'stockist__header stockists__list-header stockists__list-header--active',
        legendContentClasses: 'stockists-legend__wrapper stockists-legend__wrapper--active',
      });
    }
  }

  handlePlaceChange() {
    const place = this.autocomplete.getPlace();
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    let countryProperty = place.address_components.filter(item => item.types.indexOf('country') > -1);
    let selectedCountry = '';
    if (countryProperty.length > 0) {
      selectedCountry = countryProperty[0].long_name;
    }
    let selectedProvince = '';
    let provinceProperty = [];
    if (selectedCountry === 'United Kingdom') {
      selectedCountry = 'England';
      provinceProperty = place.address_components.filter(item => item.types.indexOf('administrative_area_level_2') > -1);
    } else {
      provinceProperty = place.address_components.filter(item => item.types.indexOf('administrative_area_level_1') > -1);
    }

    if (provinceProperty.length > 0) {
      selectedProvince = provinceProperty[0].short_name;
    }
    this.setState({
      center: {
        lat,
        lng,
      },
      selectedCountry,
      selectedProvince,
    });
  }

  getMyLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        Geocode.fromLatLng(position.coords.latitude, position.coords.longitude)
          .then(response => {
            let countryProperty = response.results[0].address_components.filter(item => item.types.indexOf('country') > -1);
            let selectedCountry = '';
            if (countryProperty.length > 0) {
              selectedCountry = countryProperty[0].long_name;
            }
            let selectedProvince = '';
            let provinceProperty = [];
            if (selectedCountry === 'United Kingdom') {
              selectedCountry = 'England';
              provinceProperty = response.results[0].address_components.filter(item => item.types.indexOf('administrative_area_level_2') > -1);
            } else {
              provinceProperty = response.results[0].address_components.filter(item => item.types.indexOf('administrative_area_level_1') > -1);
            }

            if (provinceProperty.length > 0) {
              selectedProvince = provinceProperty[0].short_name;
            }
            this.setState({
              userAddress: response.results[0].formatted_address,
              selectedProvince,
              center: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              },
            });
          },
          error => {
            window.console.log(error);
          });
      });
    }
  }

  toggleAutocompleteInput(evt) {
    evt.preventDefault();
    const {showPlacesDropdown} = this.state;
    if (showPlacesDropdown) {
      this.setState({
        showPlacesDropdown: false,
        showMyLocationLink: false,
        autocompleteInputClasses: 'col-xs-12',
        dropdownClasses: 'col-xs-12 col-lg-6 form-input__hide',
      });
      this.getMyLocation();
    } else {
      const selectedCountry = this.countrySelector.current.value;
      this.setState({
        showPlacesDropdown: true,
        showMyLocationLink: true,
        autocompleteInputClasses: 'col-xs-12 form-input__hide',
        dropdownClasses: 'col-xs-12 col-lg-6',
        selectedCountry,
      });
      this.updateProvinces(selectedCountry);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.center.lat !== this.state.center.lat && prevState.center.lng !== this.state.center.lng) {
      this.getNearbyStockists();
    }
  }

  componentDidMount() {
    const site = window.theme.activeTheme ? window.theme.activeTheme.split('-')[1] : '';
    axios({
      method: 'GET',
      url: 'https://bates-stockists-api.herokuapp.com/all-stockists/' + site,
      responseType: 'JSON',
    })
      .then(response => {
        const allCountries = response.data.stockists
                      .map(item => item.country && item.country.trim())
                      .filter(item => item !== '');
        const sortedCountries = allCountries.sort((country1, country2) => country1 > country2 ? 1 : -1);
        this.setState({
          stockists: response.data.stockists,
          countries: [...new Set(sortedCountries)],
        });
        this.setState({
          selectedCountry: this.state.countries[0],
        });
        this.updateProvinces(this.state.selectedCountry);
      })
      .catch(err => window.console.log(err));

    this.autocomplete = new google.maps.places.Autocomplete(this.autocompleteInput.current);

    this.autocomplete.addListener('place_changed', this.handlePlaceChange);
  }

  render() {
    const {
      stockists,
      countries,
      provinces,
      selectedCountry,
      selectedProvince,
      nearbyStockists,
      legend,
      legendExpandClasses,
      legendContentClasses,
      icons,
      center,
      autocompleteInputClasses,
      dropdownClasses,
      showMyLocationLink,
      userAddress,
    } = this.state;
    return (
      <div>
        <div className="container">
          <div className="page-width--narrow">
            <div className="row">
              <div className={dropdownClasses}>
                <div className="has-float-label">
                  <select ref={this.countrySelector} value={selectedCountry} onChange={(value) => this.handleCountryChange(value)} id="country">
                    {
                      countries.map((country, index) => (
                       <option value={country} key={index}>{country}</option>
                      ))
                    }
                  </select>
                  <label htmlFor="country">{window.theme.strings.country}</label>
                </div>
              </div>
              <div className={dropdownClasses}>
                <div className="has-float-label">
                  <select value={selectedProvince} onChange={(value) => this.handleProvinceChange(value)} id="region">
                    {
                      provinces.map((province, index) => (
                       <option value={province} key={index}>{province}</option>
                      ))
                    }
                  </select>
                  <label htmlFor="region">{window.theme.strings.cityRegion}</label>
                </div>
              </div>
              <div className={autocompleteInputClasses}>
                <div className="has-float-label">
                  <input
                    ref={this.autocompleteInput}
                    id="autocomplete"
                    placeholder="Enter your address"
                    type="text"
                    defaultValue={userAddress}
                  />
                  <label htmlFor="autocomplete">{window.theme.strings.enterAddress}</label>
                </div>
              </div>

              { showMyLocationLink &&
                <div className="col-xs-12 text-center stockist__get-location">
                  <a href="" className="btn--text" onClick={this.toggleAutocompleteInput}>
                    {window.theme.strings.useMyLocation}
                    <span>
                      <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><g id="Group" transform="translate(4 4)"><path className="st0" d="M5.5 8.5c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" id="Oval"/><path className="st0" d="M5 0h1v3H5z" id="Line-11"/><path className="st0" d="M8 5h3v1H8z" id="Line-11-Copy-2"/><path className="st0" d="M0 5h3v1H0z" id="Line-11-Copy-3"/><path className="st0" d="M5 8h1v3H5z" id="Line-11-Copy"/></g></svg>
                    </span>
                  </a>
                </div>
              }

              { !showMyLocationLink &&
                <div className="col-xs-12 text-center stockist__get-location">
                  <a href="" className="btn--text" onClick={this.toggleAutocompleteInput}>
                    {window.theme.strings.filterByCountry}
                  </a>
                </div>
              }
            </div>
          </div>
        </div>
        <div className="stockists__container">
          <div className="stockists__content">
            <StockistsMap stockists={stockists} center={center}/>

            <div className="stockists__legend-wrapper">
              <div className={legendExpandClasses} onClick={this.handleHideShowLegend}>
                <h4 className="h5">{window.theme.strings.legend}</h4>
                <span className="stockist__open">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path fill="#8d9794" d="M4.5 10h11v1h-11z"/>
                  </svg>
                </span>
                <span className="stockist__closed">
                  <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <g id="Group" transform="translate(5 5)">
                      <path className="st0" d="M-.5 5h11v1h-11z" id="Line-4-Copy"/>
                      <path className="st0" d="M4.5 0h1v11h-1z"/>
                    </g>
                  </svg>
                </span>
              </div>

              <div className={legendContentClasses}>
                <div className="stockists-legend__content">
                  {
                    legend.map((item, key) => (
                      <div key={key}>
                        <div className="stockists-legend__single">
                          <span dangerouslySetInnerHTML={{__html: item.icon}} className="stockists-legend__svg"></span>
                          <span>{item.title}</span>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="stockists__content stockists__list-wrapper">
            <div className="stockists__list-container">
              <div className="stockists__list-header">
                <h4 className="h5">{window.theme.strings.closestToLocation}</h4>
              </div>
              <div className="stockists__list">
                {
                  nearbyStockists.map((stockist, index) => <SingleStockist stockist={stockist.stockist} distance={stockist.distance} key={stockist.stockist.name.trim().split(' ').join() + index} icons={icons}/>)
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StockistsApp;
